/**
 * Shein mail id
 */
export const sheinMailId: string = "sheinchannel@cedcommerce.com";
/**
 * App Source Name
 */
export const APP_SOURCE_NAME = "shopify";
/**
 * App Target Name
 */
export const APP_TARGET_NAME = "shein";

/**
 * APP TAG
 */
// export const appTag = `${APP_SOURCE_NAME}_${APP_TARGET_NAME}`;
export const appTag =
  process.env.REACT_APP_SOURCE == "shein_sales_channel"
    ? "shopify_shein_saleschannel"
    : "shopify_shein";

export const nonce = "416d1177-ekld78-4e3b-b7c9-3434jsu763";
/**
 * Constant for REGEX we are using on app
 */
export const regexValidation = {
  emailFormat: /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/,
};
/**
 * url Endpoints (GET POST PUT DELETE) and redirection url
 */
export const urlFetchCalls = {
  get: {
    getSyncDisabledOrder: "shein/order/getSyncDisabledOrder",
    getSyncDisabledOrderCount: "shein/order/getSyncDisabledOrderCount",
    otpMail: "user/otpMail",
    getEditedProducts: "shein/products/getEditedProducts",
    installtionForm: "connector/get/installationForm",
    getScopes: "shopifyhome/auth/getScopesFromApp",
    userDetails: "core/user/getDetails",
    getRefineProducts: "connector/product/getRefineProducts",
    getRefineProductsCount: "connector/product/getRefineProductCount",
    getOrders: "connector/order/getAll",
    syncOrder: "shein/order/syncOrder",
    profileData: "connector/profile/getProfileData",
    productDetails: "shein/product/getProduct",
    profileDataCount: "connector/profile/getProfileDataCount",
    getShopifyAttributes: "shein/attribute/getSourceOptions",
    getQueuedTask: "connector/get/allQueuedTasks",
    deleteProfile: "connector/profile/deleteProfile",
    unassignProfile: "shein/template/saveAndUnassign",
    productManualLink: "shein/products/manualLink",
    unlinkProduct: "shein/products/unlinkProduct",
    choosePlan: "plan/plan/choose",
    isplanactive: "plan/plan/isPlanActive",
    getPlans: "plan/plan/get",
    getActivePlans: "plan/plan/getActive",
    getAllParentCategories: "shein/category/getAllParentCategories",
    getAllChildCategories: "shein/category/getChildCategories",
    dashboardGetAll: "shein/dashboard/getAll",
    getAllNotification: "connector/get/allNotifications",
    lastExportedFileUrl: "connector/csv/exportedFileName",
    isReinstallation: "shein/auth/isReinstallation",
    syncWarehouse: "shein/user/syncWarehouseUser",
    getCertificate: "shein/certificate/getCertificate",
    uploadCertificate: "shein/certificate/uploadCertificate",
    getCertificateRule: "shein/certificate/getCertificateRule",
    syncSiteList: "shein/user/syncSiteList",
    getShippingCarrier: "shein/order/getShippingCarrier",
    getTargetCarrier: "shein/order/getTargetCarrier",
    syncShipment: "shein/order/syncShipment",
    bootstrap: "shopifyhome/migration/isUserExistsInMulti",
    getWarehouseAddress: "shein/order/getWarehouseAddress",
    getAvailableLogisticsChannels: "shein/order/getAvailableLogisticsChannels",
    placeExpressOrder: "shein/order/placeExpressOrder",
    exportAddress: "shein/order/exportAddress",
  },
  post: {
    getAllNotification: "connector/get/allNotifications",
    syncDisabledSyncOrder: "shein/order/syncDisabledSyncOrder",
    userLogin: "core/user/login",
    userCreate: "core/user/create",
    getAttributes: "shein/attribute/getAllAttribute",
    checkUserExists: "shein/user/checkUserExists",
    validateOTP: "user/validateOtp",
    shopifyInstall: "shopifyhome/auth/install",
    sheinInstall: "shein/auth/install",
    productImport: "connector/product/import",
    saveStepDetails: "connector/frontend/saveStepsDetails",
    forgotPassword: "core/user/forgot",
    forgotReset: "core/user/forgotreset",
    FAQs: "webapi/rest/v1/faq/search",
    resetPassword: "core/user/resetpassword",
    productUpload: "connector/product/upload",
    sheinProductUpload: "shein/products/upload",
    productToggleState: "shein/product/toggleState",
    getErrorSolution: "webapi/rest/v1/solution/get",
    exportCSV: "connector/csv/exportCSV",
    editProduct: "shein/product/edit",
    saveBulkEdit: "shein/product/bulkEdit",
    ChargbeehostedId: "payment/chargebee/processViaHostedPageId",
    getFilterAttributes: "connector/source/getFilterAttributes",
    importCSV: "shein/products/importCsv",
    getAllAttributes: "shein/attribute/getAllAttribute",
    uploadImage: "shein/product/uploadProductsImage",
    getProductByStatus: "shein/products/getLinkProductsByStatus",
    getQueryProductsCount: "connector/profile/getQueryProductsCount",
    getQueryProducts: "connector/profile/getQueryProducts",
    getProductsBySize: "shein/products/getProductsBySize",
    saveProfileDetails: "connector/profile/saveProfile",
    deleteImage: "shein/product/deleteProductsImage",
    sheinImport: "shein/products/import",
    getProductCount: "shein/products/getProductCount",
    getProductBySpuName: "shein/products/getProductBySpuName",
    saveCategory: "shein/category/saveCategory",
    getConfig: "connector/config/getConfig",
    saveConfig: "connector/config/saveConfig",
    categorySearch: "shein/category/search",
    getMainSpec: "shein/attribute/getSelectedMainSpecification",
    priceAndInventoryUpdate: "shein/product/syncInventoryPrice",
    revokeProducts: "shein/product/revokeProducts",
    addCustomAttributes: "shein/attribute/addCustomAttributes",
    validateProfileName: "connector/profile/validateProfieName",
    getUnProcessedOrders: "shein/order/getUnprocessedOrders",
    depricatedTemplates: "shein/template/getTemplates",
    getSkcWiseStatus: "shein/products/getSkcWiseStatus",
    syncBrandList: "shein/user/syncMarketplaceData",
    updateEmail: "shein/user/updateEmail",
    registerWebhook: "shopifyhome/webhook/registerWebhook",
    getProductCertificate: "shein/certificate/getProductCertificate",
    bindCertificateToSKC: "shein/certificate/bindCertificateToSKC",
    getCertificateFilter: "shein/certificate/getCertificateFilter",
    disconnectAccount: "connector/request/updatedDisconnectAccount",
    getAttributeRules: "shein/attribute/getAttributeRules",
    createLabel: "shein/order/createLabel",
    exportAddress: "shein/order/exportAddress",
  },
  put: {},
  delete: {},
  redirect: {
    sheinSSO: "https://sso.geiwohuo.com/#/gsp/my-account/third-party-usage",
    calendlyLink: "https://calendly.com/cedmeet/shein_integartion",
    termsAndConditions:
      "https://shein-images.s3.us-east-2.amazonaws.com/TermofServicesCEDCOMMERCE.pdf",
    viewAllArticles: "https://support.cedcommerce.com/portal/en/home",
    enterprisesContactUs:
      "https://support.cedcommerce.com/portal/en/kb/shein-sales-channel",
    helpAndFaq:
      "https://support.cedcommerce.com/portal/en/kb/shein-sales-channel",
  },
};

/**
 * Email Templates Mail Subjects
 */
export const subject = {
  passwordReset: "Reset your password for React-Boiler Plate",
  otpMailSend: "Your One-time passcode for Email verification",
};

/**
 * Max Toasts Limit
 */
export const maxToasts = 3;

/**
 * Max Toasts Limit
 */
export const debounceTime = 700;

/**
 * Publish Modal Messages
 */
export const publishModalMessages: any = {
  inactive: [
    "selected products are already inactive or not listed.",
    "",
    "Inactivate active products",
  ],
  template: [
    "selected products do not have templates assigned, and they cannot be uploaded on SHEIN until a template is provided for each product.",
    "Please assign templates to all products before proceeding with the upload.",
    "Publish selected product(s)",
  ],
  active: [
    "selected products are not listed on SHEIN yet.",
    "",
    "Activate inactive products",
  ],
  linked: [
    "selected products require attribute mapping.",
    "",
    "Upload products that do not require attribute mapping",
  ],
  activePriceInventory: [
    "selected products are not listed on SHEIN yet.",
    "",
    "Update Price & Inventory of Listed Products",
  ],
};

export const numberOrFloatRegex = /^[-+]?\d+\.?\d*$/;
export const numberRegexUpto2Decimal = /^\d\d*(\.\d{0,2})?$/;
export const weightRegex = /^[0-9]\d*(\.\d{0,2})?$/;
export const integerRegex = /^[1-9]\d*$/;
export const overlay_className = "inprogress-overlay";

export const optionMappingNames: any = {
  color: "colour",
  colour: "color",
  multicolor: "multicolour",
  multicolour: "multicolor",
  grey: "gray",
  gray: "grey",
  artefact: "artifact",
  artifact: "artefact",
  "one size": "one-size",
  "one-size": "one size",
};

export const syncDataFormat = {
  "Inventory Sync": {
    last_updated_at: "",
    checked: true,
    disable: true,
  },
  "Sync Price": { last_updated_at: "", checked: true, disable: false },
};

export const orderDataFormat = {
  source_marketplace_order_id_as_order_name: false,
  order_id_format: {
    prefix: "",
    suffix: "",
  },
  sale_taxes_included: false,
  order_process_rules: {
    allowedCreateOrderStatus: [1],
  },
};

export const planCategories = ["Monthly", "Quarterly"];

export const getExportpayload = (props: any, selected: string[]) => {
  const id = props?.redux?.account?.target?.shein?.[0]?._id;
  if (selected.includes("package_settings"))
    selected = [...selected, ...packageDetails];
  const resObj: any = {
    package_length: {
      path: "edited[shop_id]|package_settings|package_dimension|package_length",
      var: {
        shop_id: id,
      },
    },
    package_width: {
      path: "edited[shop_id]|package_settings|package_dimension|package_width",
      var: {
        shop_id: id,
      },
    },
    package_height: {
      path: "edited[shop_id]|package_settings|package_dimension|package_height",
      var: {
        shop_id: id,
      },
    },
    package_dimension_unit: {
      path: "edited[shop_id]|package_settings|package_dimension|unit",
      var: {
        shop_id: id,
      },
    },
    package_weight: {
      path: "edited[shop_id]|package_settings|package_weight|value",
      var: {
        shop_id: id,
      },
    },
    package_weight_unit: {
      path: "edited[shop_id]|package_settings|package_weight|unit",
      var: {
        shop_id: id,
      },
    },
  };
  for (let key in resObj) {
    if (!selected.includes(key)) delete resObj[key];
  }

  return resObj;
};

export const packageDetails = [
  "package_length",
  "package_width",
  "package_height",
  "package_dimension_unit",
  "package_weight",
  "package_weight_unit",
];

export const unit_validation: { [key: string]: { [key: string]: number } } = {
  kg: {
    lower_limit: 0,
    upper_limit: 80,
    kg_to_gm: 1000,
    kg_to_lb: 2.20462,
    kg_to_oz: 35.274,
  },
  gm: {
    lower_limit: 0,
    upper_limit: 80000,
    gm_to_kg: 1 / 1000,
    gm_to_lb: 0.00220462,
    gm_to_oz: 0.035274,
  },
  lb: {
    lower_limit: 0,
    upper_limit: 176.36981,
    lb_to_kg: 0.45359237,
    lb_to_gm: 453.59237,
    lb_to_oz: 16,
  },
  oz: {
    lower_limit: 0,
    upper_limit: 2821.917,
    oz_to_kg: 0.028349523,
    oz_to_gm: 28.3495,
    oz_to_lb: 1 / 16,
  },
  cm: {
    lower_limit: 0,
    upper_limit: 270,
    cm_to_m: 1 / 100,
    cm_to_in: 50 / 127,
    cm_to_ft: 25 / 762,
  },
  m: {
    lower_limit: 0,
    upper_limit: 2.7,
    m_to_cm: 100,
    m_to_in: 5000 / 127,
    m_to_ft: 1250 / 381,
  },
  in: {
    lower_limit: 0,
    upper_limit: 106.3,
    in_to_cm: 127 / 50,
    in_to_m: 127 / 5000,
    in_to_ft: 1 / 12,
  },
  ft: {
    lower_limit: 0,
    upper_limit: 8.85827,
    ft_to_cm: 762 / 25,
    ft_to_m: 381 / 1250,
    ft_to_in: 12,
  },
};

export const numeric_attributes = [
  "1001609",
  "1001306",
  "1001643",
  "1000082",
  "130",
  "20",
  "1000076",
  "7",
  "76",
  "126",
  "1001486",
  "190",
  "120",
  "1001467",
  "18",
  "1001503",
  "1001926",
  "95",
  "1001948",
  "1000675",
  "1001952",
  "1000724",
  "32",
  "1001456",
  "1000546",
  "105",
  "19",
  "1001637",
  "6",
  "119",
  "71",
  "56",
  "1000008",
  "1000572",
  "1001818",
  "165",
  "1001284",
  "1000725",
  "192",
  "88",
  "1001956",
  "48",
  "1001307",
  "53",
  "108",
  "1001953",
  "1001504",
  "28",
  "1001661",
  "35",
  "1001828",
  "83",
  "1001288",
  "1001509",
  "157",
  "125",
  "50",
  "1001610",
  "118",
  "164",
  "121",
  "104",
  "188",
  "1001213",
  "1001806",
  "1001820",
  "91",
  "1001164",
  "3",
  "34",
  "1001289",
  "1001934",
  "117",
  "1001949",
  "114",
  "22",
  "1001611",
  "159",
  "1001635",
  "89",
  "156",
  "111",
  "29",
  "1001648",
  "46",
  "1000009",
  "1001435",
  "24",
  "1001951",
  "191",
  "1001505",
  "16",
  "1001758",
  "1001606",
  "15",
  "4",
  "1000068",
  "189",
  "1001387",
  "1001809",
  "85",
  "41",
  "1001827",
  "1000083",
  "1000573",
  "1001238",
  "78",
  "55",
  "100",
  "1001433",
  "122",
  "1000612",
  "1000084",
  "155",
  "1001825",
  "1001374",
  "1001947",
  "1001526",
  "1001727",
  "10",
  "1000007",
  "1001823",
  "84",
  "1001808",
  "65",
  "98",
  "57",
  "124",
  "44",
  "178",
  "153",
  "1001434",
  "1001819",
  "1000618",
  "36",
  "1001527",
];

export const certificateCategories = ["Shops", "Products"];

export const SELECTED_STORAGE_KEYS = {
  LAST_ACTIVITY_LOCAL_STORAGE_KEY: "shein-activity",
};

export const REFRESH_TOKEN = "core/token/getUserAccessToken";
